import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Row, Col, Form, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { Alerts, ButtonLoader } from "Components";
import { unAuthService } from "Service/Axios";
import { CREATE_OTP_URL } from "Constant/api";
import useAuth from "Context/useAuth";
import { useTimer } from "Utils/hooks/useTimer";
import { paths } from "Constant/paths";

export default function VerifyEmail() {
  const { t } = useTranslation();
  const location = useLocation();

  const { RegisterWithOtpValidate } = useAuth();

  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");

  const { email } = location.state || {};

  const { timeLeft, formatedTime, setTimeLeft } = useTimer();

  // On Change
  const handleChangeOtp = (e) => {
    setOtp(e.target.value);
  };

  const handlePaste = (e) => {
    const pastedValue = e.clipboardData.getData("Text");

    if (pastedValue.length === 6) {
      setOtp(pastedValue);
    }
  };

  // Handle
  const onGenerateOtp = async () => {
    setLoading(true);
    setTimeLeft(120);
    setOtpError("");
    const payload = {
      username: email,
    };
    const response = await unAuthService(CREATE_OTP_URL, "POST", payload);
    if (response && response.message === "Email has been sent") {
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  // Handle
  const onSubmitOTP = async () => {
    setLoading(true);
    try {
      const payload = {
        otp: otp,
        email: email,
      };
      const response = await RegisterWithOtpValidate(payload);
      if (response && response.message === "The otp is not valid") {
        setOtpError(t("common.messages.notification.failed.wrongOtp"));
      } else {
        setOtpError(
          t("common.messages.notification.failed.somethingWentWrong")
        );
      }
      setLoading(false);
    } catch {
      setLoading(false);
      toast.error(t("common.messages.notification.failed.serverError"));
    }
  };

  if (!email) {
    return <Navigate to={paths.registration} />;
  }

  return (
    <div className="px-lg-4 d-flex flex-column justify-content-center max-w-400 mx-auto">
      <div className="mb-5">
        <h3 className="text-xl-4xl text-2xl font-semibold">
          Verify your email
        </h3>
        <div className="text-sm text-grey-600">
          We sent a code to{" "}
          <span
            href="#"
            className="text-primary-600 text-decoration-none font-medium border-0 bg-primary-50 ms-1 px-3 py-1 rounded-md"
          >
            {email}
          </span>
        </div>
      </div>
      <Row>
        <Col sm={12} xs={12}>
          <div className="otp-form mb-4">
            <Form.Group className="mb-3" controlId="lastName">
              <Form.Label className="mb-1">Enter Verification Code</Form.Label>
              <Form.Control
                size="lg"
                className="rounded-2"
                placeholder="XXXXXX"
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={otp}
                onChange={handleChangeOtp}
                onPaste={handlePaste}
                maxLength={6}
              />
            </Form.Group>
          </div>
          {otpError && <Alerts variant="danger" message={otpError} />}
        </Col>
        <div className="mb-4 text-sm">
          {timeLeft > 0 ? (
            <span>Resend OTP in {formatedTime}</span>
          ) : (
            <>
              Didn't get a code?
              <button
                type="button"
                href="#"
                className="text-primary-600 text-decoration-none font-medium border-0 bg-primary-50 ms-1 px-3 py-1 rounded-md"
                onClick={onGenerateOtp}
              >
                Resend Code
              </button>
            </>
          )}
        </div>
        <Col sm={12} xs={12}>
          {!loading ? (
            <Button
              variant="primary"
              size="lg"
              className="w-100 font-medium"
              onClick={onSubmitOTP}
            >
              {t("common.button.verify")}
            </Button>
          ) : (
            <ButtonLoader />
          )}
        </Col>
      </Row>

      <div className="text-center mt-5 text-sm">
        <span className="text-grey-400">
          By signing up to create an account I accept Company’s
          <br />
          <a
            href="#"
            className="text-decoration-none font-semibold text-grey-700"
          >
            Terms of use & Privacy Policy.
          </a>
        </span>
      </div>
    </div>
  );
}
